import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Button
} from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { Layout } from 'components/atoms'
import { InputBuild, MultiSelectBuild, SelectBuild } from 'components/molecules'
import { Controller, useForm } from 'react-hook-form'

interface FilterProps {
    schema: any
    form: any
    title: string
    actionFilter: (value: any) => void
    loadingFilter: boolean
}

export const GlobalFilter: React.FC<FilterProps> = ({
    schema,
    form,
    actionFilter,
    title,
    loadingFilter
}) => {
    const {
        register,
        formState: { errors },
        watch,
        handleSubmit,
        reset,
        control
    } = useForm<any>({
        resolver: yupResolver(schema),
        mode: 'onChange'
    })

    const onSubmit = (value: any) => {
        actionFilter(value)
    }

    const getAllFields = (form: any) => {
        return form.map(
            (item: any) =>
                item?.input?.id ?? item?.select?.id ?? item?.multiSelect?.id
        )
    }

    const createObjectToReset = (form: any) => {
        const fields = getAllFields(form)
        let resetObject: any
        fields.forEach((field: any) => {
            resetObject = {
                ...resetObject,
                [field]: ''
            }
        })

        return resetObject
    }

    const handleClear = () => {
        reset(createObjectToReset(form), { keepDirtyValues: false })
        actionFilter(createObjectToReset(form))
    }

    return (
        <Accordion allowMultiple backgroundColor={'white'} marginBottom={4}>
            <AccordionItem>
                <h2>
                    <AccordionButton
                        backgroundColor={'white'}
                        className="white-hover"
                    >
                        <Box
                            as="h2"
                            flex="1"
                            textAlign="left"
                            fontSize={20}
                            padding={'4px 0'}
                            fontWeight={700}
                        >
                            {title}
                        </Box>
                        <AccordionIcon />
                    </AccordionButton>
                </h2>
                <AccordionPanel pb={4} backgroundColor={'white'}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box backgroundColor={'white'}>
                            <Layout type="row" gutter={{ y: 1.5 }}>
                                {form.map(
                                    (
                                        {
                                            layout,
                                            input,
                                            select,
                                            multiSelect
                                        }: any,
                                        key: any
                                    ) => (
                                        <Layout {...layout} key={key}>
                                            {multiSelect ? (
                                                <Controller
                                                    name={multiSelect.id}
                                                    control={control}
                                                    defaultValue={
                                                        multiSelect.defaultValue ||
                                                        ''
                                                    }
                                                    render={({ field }) => (
                                                        <MultiSelectBuild
                                                            {...multiSelect}
                                                            value={
                                                                field.value ||
                                                                ''
                                                            }
                                                            onChange={
                                                                field.onChange
                                                            }
                                                            onBlur={
                                                                field.onBlur
                                                            }
                                                            err={
                                                                errors[
                                                                    multiSelect.id as any
                                                                ] as any
                                                            }
                                                        />
                                                    )}
                                                />
                                            ) : select ? (
                                                <SelectBuild
                                                    {...select}
                                                    err={
                                                        errors[select.id as any]
                                                    }
                                                    {...register(
                                                        select.id as any
                                                    )}
                                                />
                                            ) : (
                                                input && (
                                                    <InputBuild
                                                        {...input}
                                                        err={
                                                            errors[
                                                                input.id as any
                                                            ]
                                                        }
                                                        {...register(
                                                            input.id as any
                                                        )}
                                                        value={watch(
                                                            input?.id as any
                                                        )}
                                                    />
                                                )
                                            )}
                                        </Layout>
                                    )
                                )}
                            </Layout>
                            <Box
                                paddingY={8}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                gap={6}
                            >
                                <Button
                                    colorScheme="primary"
                                    variant="outline"
                                    onClick={handleClear}
                                >
                                    Limpar Campos
                                </Button>
                                <Button
                                    colorScheme="primary"
                                    type="submit"
                                    isLoading={loadingFilter}
                                >
                                    Filtrar
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
    )
}
